import { render, staticRenderFns } from "./DsAudienceFooter.vue.js?vue&type=template&id=122b531d!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceFooter.vue?vue&type=template&id=122b531d"
import script from "./DsAudienceFooter.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceFooter.vue?vue&type=script&lang=js"
export * from "./DsAudienceFooter.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DsAudienceFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports